import React from "react";
import { Routes, Route } from "react-router-dom";
import FinanceDashboard from "./components/FinanceDashboard";
import PurchaseRequestFinancials from "./components/PurchaseRequestFinancials";
import InventoryFinancials from "./components/InventoryFinancials";
import SalesFinancials from "./components/SalesFinancials";
import HRExpenses from "./components/HRExpenses";
import PayrollFinancials from "./components/PayrollFinancials";
import AccountsManagement from "./AccountsManagement";
import TransactionsManagement from "./TransactionsManagement";
import TransactionPayment from "./TransactionPayment";
import BudgetManagement from "./BudgetManagement";
import ConsolidatedReports from "./components/ConsolidatedReports";
import ReportsCenter from "./ReportsCenter";
import InvoiceGeneration from "./InvoiceGeneration";
import ImprestManagement from "./ImprestManagement";
import PayablesManagement from "./PayablesManagement";
import ReceivablesManagement from "./ReceivablesManagement";

const Finance = () => {
  return (
    <Routes>
      <Route index element={<FinanceDashboard />} />
      <Route path="purchase-requests" element={<PurchaseRequestFinancials />} />
      <Route path="inventory" element={<InventoryFinancials />} />
      <Route path="sales" element={<SalesFinancials />} />
      <Route path="hr-expenses" element={<HRExpenses />} />
      <Route path="payroll" element={<PayrollFinancials />} />
      <Route path="accounts" element={<AccountsManagement />} />
      <Route path="transactions" element={<TransactionsManagement />} />
      <Route path="transaction-payment" element={<TransactionPayment />} />
      <Route path="budgets" element={<BudgetManagement />} />
      <Route path="imprest" element={<ImprestManagement />} />
      <Route path="reports" element={<ConsolidatedReports />} />
      <Route path="reports-center/*" element={<ReportsCenter />} />
      <Route path="invoices" element={<InvoiceGeneration />} />
      <Route path="payables" element={<PayablesManagement />} />
      <Route path="receivables" element={<ReceivablesManagement />} />
    </Routes>
  );
};

export default Finance;
